import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#2065d1",
      dark: "#103996",
      light: "#76b0f1",
    },
    secondary: {
      main: "#637381",
    },
    background: {
      default: "#f9fafb",
    },
    grey: {
      100: "#f9fafb",
      200: "#f4f6f8",
      300: "#dfe3e8",
      400: "#c4cdd5",
      500: "#919eab",
      600: "#637381",
      700: "#454f5b",
      800: "#212b36",
    },
  },
  typography: {
    fontFamily: `"Public Sans", "Inter", "Manrope", sans-serif`,
  },
  shape: {
    borderRadius: 10,
  },
});
